(function () {
  'use strict';

  var SV = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
  var I = {
    check: '<svg ' + SV + ' stroke-width="2.4"><path d="M5 12l5 5l10 -10"/></svg>',
    left: '<svg ' + SV + '><path d="M15 6l-6 6l6 6"/></svg>',
    x: '<svg ' + SV + '><path d="M18 6l-12 12M6 6l12 12"/></svg>',
    skip: '<svg ' + SV + '><path d="M4 5v14l12 -7z"/><path d="M20 5l0 14"/></svg>',
    refresh: '<svg ' + SV + '><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"/><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
    pm: '<svg ' + SV + '><path d="M17 12h-10M12 7v10"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/></svg>',
    pause: '<svg ' + SV + '><path d="M6 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"/><path d="M14 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"/></svg>',
    chat: '<svg ' + SV + '><path d="M8 9h8M8 13h6"/><path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z"/></svg>',
    heart: '<svg ' + SV + '><path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.566z"/></svg>',
    done: '<svg ' + SV + '><path d="M5 12l5 5l10 -10"/></svg>'
  };

  // \u89e3\u7d04\u7406\u7531\uff08id\u306f\u65e5\u672c\u8a9e\u3067\u30b5\u30fc\u30d0\u30fc\u306b\u9001\u4fe1\u3055\u308c\u308b\u5024\u3002
  // Mikawaya\u7ba1\u7406\u753b\u9762\u3084\u30a8\u30af\u30b9\u30dd\u30fc\u30c8\u3067\u305d\u306e\u307e\u307e\u8868\u793a\u3055\u308c\u308b\u524d\u63d0\u3002
  var REASONS = [
    { id: '\u307e\u3060\u4f59\u3063\u3066\u3044\u308b',       label: '\u307e\u3060\u4f59\u3063\u3066\u3044\u308b' },
    { id: '\u4fa1\u683c\u304c\u8ca0\u62c5\u306b\u306a\u3063\u3066\u304d\u305f', label: '\u4fa1\u683c\u304c\u8ca0\u62c5\u306b\u306a\u3063\u3066\u304d\u305f' },
    { id: '\u611b\u72ac\u304c\u98df\u3079\u306a\u304f\u306a\u3063\u305f',   label: '\u611b\u72ac\u304c\u98df\u3079\u306a\u304f\u306a\u3063\u305f' },
    { id: '\u3057\u3070\u3089\u304f\u5fc5\u8981\u306a\u3044',       label: '\u3057\u3070\u3089\u304f\u5fc5\u8981\u306a\u3044' },
    { id: '\u4ed6\u306e\u5546\u54c1\u306b\u5909\u3048\u308b',       label: '\u4ed6\u306e\u5546\u54c1\u306b\u5909\u3048\u308b' },
    { id: '\u611b\u72ac\u304c\u4ea1\u304f\u306a\u3063\u305f',       label: '\u611b\u72ac\u304c\u4ea1\u304f\u306a\u3063\u305f' }
  ];

  // pet_passed \u306b\u76f8\u5f53\u3059\u308b\u7406\u7531\u306e\u5024\uff08\u5f15\u304d\u6b62\u3081\u306a\u3057\u30fb\u5373\u6642\u89e3\u7d04\u306e\u5206\u5c90\u306b\u4f7f\u7528\uff09
  var PET_PASSED_REASON = '\u611b\u72ac\u304c\u4ea1\u304f\u306a\u3063\u305f';

  var OFFERS = {};
  OFFERS['\u307e\u3060\u4f59\u3063\u3066\u3044\u308b'] = {
    tag: '\u89e3\u7d04\u3057\u306a\u304f\u3066\u3082\u8abf\u6574\u3067\u304d\u307e\u3059',
    title: '\u304a\u5c4a\u3051\u306e\u9593\u9694\u3092\u7a7a\u3051\u307e\u305b\u3093\u304b',
    body: '\u5c0f\u578b\u72ac\u3084\u30b7\u30cb\u30a2\u72ac\u306e\u5834\u5408\u3001\u60f3\u5b9a\u3088\u308a\u98df\u3079\u308b\u91cf\u304c\u5c11\u306a\u304f\u3001\u30d5\u30fc\u30c9\u304c\u4f59\u308a\u304c\u3061\u306b\u306a\u308b\u3053\u3068\u304c\u3042\u308a\u307e\u3059\u3002\u9593\u9694\u3092\u4f38\u3070\u3059\u304b\u3001\u6b21\u56de\u3092\u98db\u3070\u3059\u3060\u3051\u3067\u3061\u3087\u3046\u3069\u3088\u304f\u306a\u308b\u304b\u3082\u3057\u308c\u307e\u305b\u3093\u3002',
    actions: [
      { act: 'interval', icon: 'refresh', label: '\u304a\u5c4a\u3051\u9593\u9694\u3092\u5909\u3048\u308b', primary: true },
      { act: 'skip', icon: 'skip', label: '\u6b21\u56de\u3060\u3051\u30b9\u30ad\u30c3\u30d7\u3059\u308b' }
    ]
  };
  OFFERS['\u4fa1\u683c\u304c\u8ca0\u62c5\u306b\u306a\u3063\u3066\u304d\u305f'] = {
    tag: '\u3054\u8ca0\u62c5\u3092\u8efd\u304f\u3059\u308b\u65b9\u6cd5\u304c\u3042\u308a\u307e\u3059',
    title: '\u500b\u6570\u3084\u9593\u9694\u306e\u898b\u76f4\u3057\u3082\u3067\u304d\u307e\u3059',
    body: '1\u56de\u3042\u305f\u308a\u306e\u500b\u6570\u3092\u6e1b\u3089\u3057\u305f\u308a\u3001\u304a\u5c4a\u3051\u306e\u9593\u9694\u3092\u4f38\u3070\u3059\u3053\u3068\u3067\u3001\u6708\u3005\u306e\u3054\u8ca0\u62c5\u3092\u62bc\u3055\u3048\u3089\u308c\u307e\u3059\u3002\u5b9a\u671f\u4fbf\u306e\u5272\u5f15\u306f\u305d\u306e\u307e\u307e\u9069\u7528\u3055\u308c\u307e\u3059\u3002',
    actions: [
      { act: 'qty', icon: 'pm', label: '\u500b\u6570\u3092\u6e1b\u3089\u3059', primary: true },
      { act: 'interval', icon: 'refresh', label: '\u304a\u5c4a\u3051\u9593\u9694\u3092\u4f38\u3070\u3059' }
    ]
  };
  OFFERS['\u611b\u72ac\u304c\u98df\u3079\u306a\u304f\u306a\u3063\u305f'] = {
    tag: '\u7363\u533b\u5e2b\u306b\u3054\u76f8\u8ac7\u3044\u305f\u3060\u3051\u307e\u3059',
    title: '\u98df\u3079\u306a\u3044\u7406\u7531\u3092\u4e00\u7dd2\u306b\u8003\u3048\u3055\u305b\u3066\u304f\u3060\u3055\u3044',
    body: '\u4f53\u8abf\u3084\u5b63\u7bc0\u3001\u5e74\u9f62\u306b\u3088\u3063\u3066\u3001\u4e00\u6642\u7684\u306b\u98df\u6b32\u304c\u843d\u3061\u308b\u3053\u3068\u306f\u3088\u304f\u3042\u308a\u307e\u3059\u3002\u98df\u3079\u65b9\u306e\u5de5\u592b\u3084\u3001\u5225\u306e\u30d5\u30ec\u30fc\u30d0\u30fc\u3067\u6539\u5584\u3059\u308b\u30b1\u30fc\u30b9\u3082\u3054\u3056\u3044\u307e\u3059\u3002LINE\u3067\u7363\u533b\u5e2b\u306b\u76f8\u8ac7\u3067\u304d\u307e\u3059\u3002',
    actions: [
      { act: 'line', icon: 'chat', label: 'LINE\u3067\u7363\u533b\u5e2b\u306b\u76f8\u8ac7\u3059\u308b', primary: true, href: 'LINE_URL' },
      { act: 'pause', icon: 'pause', label: '\u3068\u308a\u3042\u3048\u305a\u304a\u4f11\u307f\u3059\u308b' }
    ]
  };
  OFFERS['\u3057\u3070\u3089\u304f\u5fc5\u8981\u306a\u3044'] = {
    tag: '\u89e3\u7d04\u3057\u306a\u304f\u3066\u3082\u5927\u4e08\u592b\u3067\u3059',
    title: '\u304a\u4f11\u307f\u306b\u3057\u3066\u304a\u3051\u307e\u3059',
    body: '\u304a\u4f11\u307f\u4e2d\u306f\u304a\u5c4a\u3051\u3082\u304a\u652f\u6255\u3044\u3082\u767a\u751f\u3057\u307e\u305b\u3093\u3002\u307e\u305f\u5fc5\u8981\u306b\u306a\u3063\u305f\u3068\u304d\u306b\u3001\u30de\u30a4\u30da\u30fc\u30b8\u304b\u3089\u3044\u3064\u3067\u3082\u518d\u958b\u3067\u304d\u307e\u3059\u3002\u3054\u5951\u7d04\u5185\u5bb9\u3082\u305d\u306e\u307e\u307e\u6b8b\u308a\u307e\u3059\u3002',
    actions: [
      { act: 'pause', icon: 'pause', label: '\u5b9a\u671f\u4fbf\u3092\u304a\u4f11\u307f\u306b\u3059\u308b', primary: true }
    ]
  };
  OFFERS['\u4ed6\u306e\u5546\u54c1\u306b\u5909\u3048\u308b'] = null;
  OFFERS[PET_PASSED_REASON] = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function reasonsHTML(sel) {
    return REASONS.map(function (r) {
      var on = sel === r.id;
      return '<button type="button" class="spc-reason' + (on ? ' is-sel' : '') + '" data-reason="' + esc(r.id) + '">' +
        '<span class="spc-reason-mark">' + I.check + '</span>' +
        '<span>' + esc(r.label) + '</span></button>';
    }).join('');
  }

  function step1HTML() {
    return '<div class="spc-step">' +
      '<p class="spc-lead">\u5dee\u3057\u652f\u3048\u306a\u3051\u308c\u3070\u3001\u7406\u7531\u3092\u6559\u3048\u3066\u304f\u3060\u3055\u3044</p>' +
      '<p class="spc-sub">\u4eca\u5f8c\u306e\u3054\u306f\u3093\u3065\u304f\u308a\u306e\u53c2\u8003\u306b\u3055\u305b\u3066\u3044\u305f\u3060\u304d\u307e\u3059\u3002</p>' +
      '<div class="spc-reasons">' + reasonsHTML(null) + '</div></div>';
  }

  function offerHTML(rid, ctx) {
    var o = OFFERS[rid];
    if (!o) return finalHTML(rid, ctx);
    var acts = o.actions.map(function (a) {
      var cls = 'sp-btn' + (a.primary ? ' sp-btn-primary' : '');
      var ic = I[a.icon] || '';
      if (a.href === 'LINE_URL' && ctx.lineUrl) {
        return '<a class="' + cls + '" href="' + esc(ctx.lineUrl) + '" target="_blank" rel="noopener">' +
          ic + '<span>' + esc(a.label) + '</span></a>';
      }
      return '<button type="button" class="' + cls + '" data-offer="' + a.act + '">' +
        ic + '<span>' + esc(a.label) + '</span></button>';
    }).join('');

    return '<div class="spc-step">' +
      '<button type="button" class="spc-back" data-nav="step1">' + I.left + '\u7406\u7531\u3092\u9078\u3073\u76f4\u3059</button>' +
      '<div class="spc-offer">' +
        '<span class="spc-offer-tag">' + esc(o.tag) + '</span>' +
        '<p class="spc-offer-title">' + esc(o.title) + '</p>' +
        '<p class="spc-offer-body">' + esc(o.body) + '</p>' +
        '<div class="spc-offer-actions">' + acts + '</div>' +
      '</div>' +
      '<button type="button" class="spc-keep" data-nav="final">\u305d\u308c\u3067\u3082\u89e3\u7d04\u306b\u9032\u3080</button>' +
      '</div>';
  }

  function finalHTML(rid, ctx) {
    var back = OFFERS[rid]
      ? '<button type="button" class="spc-back" data-nav="offer">' + I.left + '\u623b\u308b</button>'
      : '<button type="button" class="spc-back" data-nav="step1">' + I.left + '\u7406\u7531\u3092\u9078\u3073\u76f4\u3059</button>';
    return '<div class="spc-step">' + back +
      '<div class="spc-final">' +
        '<p class="spc-lead">\u5b9a\u671f\u4fbf\u3092\u89e3\u7d04\u3057\u307e\u3059</p>' +
        '<p class="spc-sub" style="margin-bottom:0">\u4ee5\u4e0b\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044\u3002</p>' +
        '<ul class="spc-final-list">' +
          '<li>\u6b21\u56de\u4ee5\u964d\u306e\u304a\u5c4a\u3051\u3068\u304a\u652f\u6255\u3044\u306f\u505c\u6b62\u3055\u308c\u307e\u3059</li>' +
          '<li>\u89e3\u7d04\u3057\u305f\u5b9a\u671f\u4fbf\u306f\u5143\u306b\u623b\u305b\u307e\u305b\u3093</li>' +
          '<li>\u518d\u3073\u3054\u5229\u7528\u306e\u969b\u306f\u3001\u65b0\u3057\u304f\u304a\u7533\u3057\u8fbc\u307f\u304c\u5fc5\u8981\u3067\u3059</li>' +
        '</ul>' +
        '<button type="button" class="spc-danger" data-do-cancel="1">\u89e3\u7d04\u3092\u78ba\u5b9a\u3059\u308b</button>' +
        '<button type="button" class="spc-keep" data-nav="close">\u3084\u3081\u3066\u304a\u304f</button>' +
      '</div></div>';
  }

  function memorialHTML(ctx) {
    var name = ctx.dogName ? esc(ctx.dogName) + '\u3061\u3083\u3093' : '\u611b\u72ac\u306e\u5b50';
    return '<div class="spc-memorial">' +
      '<div class="spc-done-icon">' + I.heart + '</div>' +
      '<p class="spc-memorial-body">' +
        name + '\u3068\u306e\u6bce\u65e5\u306b\u3001<br>HITOWAN\u3092\u9078\u3093\u3067\u3044\u305f\u3060\u304d<br>\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3057\u305f\u3002<br><br>' +
        '\u3054\u306f\u3093\u306e\u6642\u9593\u304c\u3001<br>\u5c11\u3057\u3067\u3082\u3044\u3044\u6642\u9593\u306b<br>\u306a\u3063\u3066\u3044\u305f\u306a\u3089\u5e78\u3044\u3067\u3059\u3002' +
      '</p>' +
      '<p class="spc-memorial-done">\u5b9a\u671f\u4fbf\u306e\u304a\u624b\u7d9a\u304d\u306f\u5b8c\u4e86\u3057\u307e\u3057\u305f\u3002</p>' +
      '<button type="button" class="sp-btn" data-nav="close-done">\u9589\u3058\u308b</button></div>';
  }

  function doneHTML() {
    return '<div class="spc-done">' +
      '<div class="spc-done-icon">' + I.done + '</div>' +
      '<p class="spc-done-title">\u89e3\u7d04\u306e\u304a\u624b\u7d9a\u304d\u304c\u5b8c\u4e86\u3057\u307e\u3057\u305f</p>' +
      '<p class="spc-done-body">\u3053\u308c\u307e\u3067\u3054\u5229\u7528\u3044\u305f\u3060\u304d\u3001<br>\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3057\u305f\u3002</p>' +
      '<button type="button" class="sp-btn" data-nav="close-done">\u9589\u3058\u308b</button></div>';
  }

  window.SPCancel = {
    REASONS: REASONS,
    OFFERS: OFFERS,
    PET_PASSED_REASON: PET_PASSED_REASON,
    step1HTML: step1HTML,
    offerHTML: offerHTML,
    finalHTML: finalHTML,
    memorialHTML: memorialHTML,
    doneHTML: doneHTML,
    reasonsHTML: reasonsHTML
  };
})();
